import React from 'react';
import { Form, Input, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { IRequirement, ICustomRequirements } from '@partsbadger/types';
import { UploadFile } from '@partsbadger/library';
import type { UploadFile as AntdUploadFile } from 'antd/es/upload/interface';

const { TextArea } = Input;

interface ExtraInputsProps {
    customRequirements: Array<ICustomRequirements>;
    requirements: Array<IRequirement>;
    handleChange: (values: Array<ICustomRequirements>) => void;
}

export const RenderExtraInputs = ({ customRequirements, requirements, handleChange }: ExtraInputsProps) => {
    if (!customRequirements) {
        return <div />;
    }
    return (
        <React.Fragment>
            {customRequirements?.map(item => {
                const option = requirements.find(record => Number(record.id) === Number(item?.key));

                if (!option) {
                    return null;
                }
                const { field_type } = option;

                if (field_type === 'input') {
                    return (
                        <Form.Item key={`input-${item.key}`} label={item.label}>
                            <Input
                                style={{ maxWidth: 300 }}
                                size={'small'}
                                required
                                defaultValue={item.value ?? ''}
                                onBlur={event => {
                                    const new_data = customRequirements.map(old_record => {
                                        return old_record.key === item.key
                                            ? {
                                                  ...old_record,
                                                  value: event.target.value,
                                              }
                                            : old_record;
                                    });
                                    handleChange(new_data);
                                }}
                            />
                        </Form.Item>
                    );
                }

                if (field_type === 'inputtext') {
                    return (
                        <Form.Item key={`input-${item.key}`} label={item.label}>
                            <TextArea
                                style={{ maxWidth: 300 }}
                                size={'small'}
                                required
                                defaultValue={item.value ?? ''}
                                onBlur={event => {
                                    const new_data = customRequirements.map(old_record => {
                                        return old_record.key === item.key
                                            ? {
                                                  ...old_record,
                                                  value: event.target.value,
                                              }
                                            : old_record;
                                    });
                                    handleChange(new_data);
                                }}
                            />
                        </Form.Item>
                    );
                }

                if (field_type === 'file') {
                    const defaultFileList: AntdUploadFile<unknown>[] =
                        item?.files?.map(
                            (file): AntdUploadFile<unknown> => ({
                                uid: String(file.id),
                                name: String(file.filename),
                                status: 'done',
                                url: String(file.file),
                                response: {
                                    id: file.id,
                                    filename: file.filename,
                                    file: file.file,
                                },
                            })
                        ) ?? [];

                    return (
                        <Form.Item key={`upload-${item.key}`} label={item.label}>
                            <UploadFile
                                onChange={info => {
                                    const fileList = info;
                                    const allFilesRemoved = fileList.length === 0;

                                    const files = fileList
                                        ?.filter(f => f?.status === 'done')
                                        .map(file => {
                                            return {
                                                id: file.response.id,
                                                filename: file.response.filename,
                                                file: file.response.file,
                                            };
                                        });

                                    if (allFilesRemoved || files.length) {
                                        const items = customRequirements?.map(old_record => {
                                            return old_record.key === item.key
                                                ? {
                                                      ...old_record,
                                                      files: !allFilesRemoved ? files : [],
                                                  }
                                                : old_record;
                                        });

                                        handleChange(items);
                                    }
                                }}
                                defaultFileList={defaultFileList}
                                multiple
                            >
                                <Button>
                                    <UploadOutlined /> Click to upload
                                </Button>
                            </UploadFile>
                        </Form.Item>
                    );
                }

                return null;
            })}
        </React.Fragment>
    );
};
